import styled from 'styled-components';
import { lighten, desaturate } from 'polished';

const TemplateEngine = styled.div`
  .flexi-tab-label-active {
    font-weight: 700;
  }

  & .layout-grid {
    & .list-view {
      display: none;
    }
  }

  & .layout-list {
    & .grid-view {
      display: none;
    }

    & .list-view {
      margin-top: -4.2rem;
    }
  }

  & .flexi-table {
    overflow-x: unset;
  }

  & .button-toggle {
    z-index: 1;
    @media (max-width: 800px) {
      display: none;
    }
    & .active {
      background-color: ${({ theme }) => theme.PrimaryColor};
      color: #fff;
    }
    & .deactivated {
      border: 2px solid ${({ theme }) => theme.PrimaryRed};
      border-bottom: 0;
    }
    & .flexi-button {
      &:first-child {
        border-right: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      &:last-child {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }

  & .thumbnail-wrapper {
    display: grid;
    grid-template-columns: 30px 1fr;
    max-width: 230px;

    & .template-name {
      transform: rotate(-90deg);
      position: relative;
      left: -7.56rem;
      bottom: -7.7rem;
      text-align: right;
      height: 30px;
      width: 276px;
      display: flex;
      justify-content: flex-end;

      & .active {
        border: 2px solid ${({ theme }) => theme.PrimaryColor};
        border-bottom: 0;
      }

      & .deactivated {
        border-bottom: 0;
        opacity: 0.6;
      }

      span {
        background: #f2f2f8;
        padding: 10px;
        font-size: 10px;
        line-height: 10px;
        width: max-content;
        border-radius: 10px 0 0 0;
        box-shadow: 0 -2px 6px ${({ theme }) => desaturate(0.3, lighten(0.25, theme.PrimaryColor))};
      }
    }

    & .thumbnail-selector {
      padding: 0;
      width: 100%;
      max-width: 200px;
      background-color: #f2f2f8;
      box-shadow: 0 4px 10px
        ${({ theme }) => desaturate(0.3, lighten(0.2, theme.PrimaryColor))};

      border-radius: 3px;

      img {
        width: 100%;
      }

      & .thumbail-des {
        width: 100%;
        flex-direction: column;
        justify-content: space-between;
      }

      & .active {
        border: 2px solid ${({ theme }) => theme.PrimaryColor};
        box-shadow: 0 4px 25px
          ${({ theme }) => desaturate(0.6, lighten(0.05, theme.PrimaryColor))};
        border-radius: 0 3px 3px 3px;
      }
      & .deactivated {
        opacity: 0.3;
        box-shadow:6px 2px 10px 7px #fff;
        border-radius: 0 3px 3px 3px;
        cursor: not-allowed;
      }

      & .thumbnail-container {
      }
    }
  }
`;

export default TemplateEngine;
